module.exports = __webpack_public_path__ + "static/openbci-completed-743795f1f567b657d025ccd759ec0f7e.jpg";